/* eslint-disable react/prop-types */
import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useCallback, useRef, useEffect } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';

import { useState } from 'react';
import { useMemo } from 'react';
import { toPng } from 'html-to-image';
import cloudDownload from 'assets/img/icons/cloud-download.svg';
import LeafletMapSideBySide from './LeafletMapSideBySide';
import Model from './Model';
import { FiInfo } from 'react-icons/fi';
import { isEmpty } from 'lodash';

const LandCoverMonitorMap = ({
  landCoverData,
  coordinates,
  info,
  legendData,
  variant,
  label
}) => {
  // const options = useMemo(() => {
  //   const sortedData = [...landCoverData].sort((a, b) =>
  //     a.variant.localeCompare(b.variant)
  //   );

  //   return sortedData?.map(item => {
  //     const year = item.variant;
  //     return { key: item.key, value: year };
  //   });
  // }, [landCoverData]);

  const [leftSide, setLeftSide] = useState(variant[0]);
  const [rightSide, setRightSide] = useState(variant[variant?.length - 1]);
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const targetElementRef = useRef(null);

  const onButtonClick = useCallback(async () => {
    if (targetElementRef.current === null) {
      return;
    }
    const title = label;
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hour = String(currentDate.getHours()).padStart(2, '0');
    const minute = String(currentDate.getMinutes()).padStart(2, '0');
    const second = String(currentDate.getSeconds()).padStart(2, '0');

    const timestamp = `${year}-${month}-${day}-${hour}-${minute}-${second}`;
    const filename = `${title}_${timestamp}.png`;

    //Timestamp in the image
    const timestampElement = document.createElement('div');
    timestampElement.textContent =
      `Downloaded on: ` + new Date().toLocaleString();
    timestampElement.style.position = 'absolute';
    timestampElement.style.bottom = '2px';
    timestampElement.style.right = '10px';
    targetElementRef.current.appendChild(timestampElement);

    try {
      const dataUrl = await toPng(targetElementRef.current);

      // Remove the timestamp element after capturing the
      targetElementRef.current.removeChild(timestampElement);

      const link = document.createElement('a');
      link.download = filename;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error(err);
    }
  }, [targetElementRef, landCoverData]);

  useEffect(() => {
    if (landCoverData) {
      setLeftSide(variant[0]);
      setRightSide(variant[variant.length - 1]);
    }
  }, [landCoverData, variant]);

  const endElement = (
    <Row className="g-0 align-items-center justify-content-end">
      <Col className="col-auto">
        <Form.Select
          className="ps-2 pe-5 py-0"
          defaultValue={variant[0]}
          name="leftSide"
          onChange={e => setLeftSide(e.target.value)}
        >
          {variant?.map(item => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col className="text-center p-0 d-flex align-align-items-center">
        <span className="m-auto px-2">vs</span>
      </Col>
      <Col className="col-auto">
        <Form.Select
          className="ps-2 pe-5 py-0"
          defaultValue={variant[variant?.length - 1]}
          name="leftSide"
          onChange={e => setRightSide(e.target.value)}
        >
          {variant?.map(item => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col xs={3} style={{ width: 'fit-content', paddingLeft: '4px' }}>
        {/* <button onClick={onButtonClick}>Capture Image</button> */}
        <Button
          variant="light"
          size="sm"
          className="border-300 me-1 text-500"
          onClick={onButtonClick}
        >
          <img src={cloudDownload} alt="Download" width={15} />
        </Button>
      </Col>
    </Row>
  );

  const firstKey = Object.keys(landCoverData)[0];
  return (
    <Card className="h-100 overflow-hidden card" ref={targetElementRef}>
      <FalconCardHeader
        title={label}
        titleTag="h5"
        light={true}
        endEl={endElement}
        desc={landCoverData[0]?.desc}
        infoBtn={!isEmpty(info) && <FiInfo onClick={handleShowModal} />}
      />
      <Card.Body className="h-100 p-0" dir="ltr">
        <LeafletMapSideBySide
          data={{
            coordinates: coordinates,
            mapData: landCoverData,
            legendData: legendData
          }}
          leftSide={leftSide}
          rightSide={rightSide}
          label={label}
          className="h-100 bg-white"
          style={{ minHeight: '400px' }}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        <h5 className="mb-0 infrence-info">{landCoverData[firstKey]?.info}</h5>
      </Card.Footer>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={info}
        title={label}
      />
    </Card>
  );
};

export default LandCoverMonitorMap;
